import { IssuePieChartByAssigneeReportResult } from '@tap/data-providers';
import { XGridTableWrap, numberHelper } from '@tap/mui-ui';

/* Таблица Круговая диаграмма по исполнителям для заявок
*/


type IssuePieChartByAssigneeTableProps = {
    initialData: IssuePieChartByAssigneeReportResult[],
    totalIssueCount: number,
}

export default function IssuePieChartByAssigneeTable({initialData, totalIssueCount}: IssuePieChartByAssigneeTableProps) {

    return (
        <XGridTableWrap
            rows={initialData}
            dataIsLoading={false}
            tableHeight={'calc(100vh - 160px)'}
            tableWidth={'90%'}
            columns={[
                {
                    field: 'assigneeName',
                    headerName: 'Исполнитель',
                    sortable: false,
                    type: 'string',
                    flex: 1,
                },
                {
                    field: 'issueCount',
                    headerName: 'Количество заявок',
                    sortable: false,
                    type: 'number',
                    flex: 1,
                },
                {
                    field: 'id',
                    headerName: 'Процент от общего количества',
                    sortable: false,
                    type: 'number',
                    flex: 1,
                    renderCell: cellParams =>  `${numberHelper.floatFormat((cellParams.row.issueCount/totalIssueCount)*100)}%`,
                },
            ]}

        />
    );
}

